import _ from "lodash"
import moment from "moment"

export const RIGHT = "right"
export const LEFT = "left"

/**
 * A monetary field in JUMP has a dedicated contract like:
 * <pre>
 *    {
 *       "text": "41 267,8 €",
 *       "filter": {
 *         "amount": 41267.8,
 *         "devise": "€"
 *       },
 *       "color": "",
 *       "style": {
 *         "textAlign": "left"
 *       },
 *       "cell_actions": {},
 *       "locked_cell": false
 *     }
 * </pre>
 * @param cellFilterValue
 * @returns {boolean}
 */
export function isMonetaryCell(cellFilterValue) {
  if (!_.isObject(cellFilterValue)) {
    return false
  }

  return _.has(cellFilterValue, "amount") && _.has(cellFilterValue, "devise")
}

/**
 * JUMP Server / reporting has <b>cell style definition inconsistent</b>, so I decided to re implement the wheel (yes I did...)
 *
 * Implementation below infers cell type based on `cell.filter` value.
 *
 *
 * @param cellFilterValue
 * @returns {string}
 */
export function inferTextAlignFromFilterType(cellFilterValue) {
  if (_.isNumber(cellFilterValue)) {
    return RIGHT
  }

  if (moment(cellFilterValue, true).isValid()) {
    return RIGHT
  }

  if (isMonetaryCell(cellFilterValue)) {
    return RIGHT
  }

  return LEFT
}
